'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default function() {
    return {
        restrict: 'A',
        template: require('../view/table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            def: '=?myDef',
        },
        controller: ['$scope', '$log', '$utils', 'StatusService', 'LandRestService', 'Notification', '$security', 'LandService', 'ModalService', 'AttachmentService',
            function($scope, $log, $utils, StatusService, LandRestService, Notification, $security, LandService, ModalService, AttachmentService) {
                $scope.getStatusDisplayName = StatusService.getDisplayName;
                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.select = select;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;
                $scope.showAttachments = AttachmentService.show;

                $scope.loading = true;

                $scope.columns = [{
                    name: 'Код',
                    data: 'id',
                }, {
                    name: 'Муниципальное образование',
                    data: 'municipality.name',
                }, {
                    name: 'Кадастровый номер',
                    data: 'regNum',
                    type: 'link',
                    getHref: (item) => LandService.getExternalURI(item),
                }, {
                    name: 'Категория земель',
                    data: 'category.name',
                }, {
                    name: 'Владелец',
                    data: 'owner',
                }, {
                    name: 'Форма владения',
                    data: 'ownershipForm.name',
                }, {
                    name: 'Площадь, кв. м.',
                    data: 'area',
                }, {
                    name: 'Вложения',
                    data: 'attachments',
                    type: 'attachments',
                }];

                $scope.searching = {
                    isSearch: $scope.isSearch,
                    filter: null,
                };

                $scope.pagination = {
                    isPaging: $scope.isPaging,
                    page: 1,
                    size: $scope.isPaging ? 10 : null,
                    totalPages: null,
                    totalItems: null,
                };

                // тулбокс таблицы
                $scope.toolbox = {
                    // кнопки на панели управления
                    buttons: {
                        // создание
                        create: {
                            show: () => $security.isAllowWrite('/lands'),
                            click: () => LandService.create($scope.def).result.then((data) =>
                                LandRestService.create(null, {'form': data}, (data) => {
                                    $scope.selectedItem = data._embedded;
                                    $scope.items.push(data._embedded);
                                    $scope.refresh();
                                }), () => {
                            }),
                            disabled: () => false,
                        },
                        // редактирование
                        edit: {
                            show: () => isSelected(),
                            click: (item) => LandService.edit(item).result.then(function(data) {
                                LandRestService.update({landId: data.id}, {'form': data}, (data) => {
                                    angular.copy(data._embedded, item);
                                    $scope.refresh();
                                });
                            }, () => {
                            }),
                            disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                        },
                        // удаление
                        remove: {
                            show: () => isSelected() && $security.isAllowWrite('/lands'),
                            click: (item) => ModalService.danger({
                                message: 'Запись будет удалена без возможности восстановления! Вы действительно желаете удалить данную запись?',
                                apply: 'Да',
                                cancel: 'Нет',
                            }).result.then(() => LandRestService.remove({landId: item.id}, (data) => {
                                $scope.items.splice($scope.items.indexOf(item), 1);
                                $scope.refresh();
                                Notification.success({
                                    message: 'Земельный участок удален!',
                                });
                            }, (error) => {
                                Notification.warning({
                                    title: 'Внимание!',
                                    message: 'Данную запись удалить нельзя,<br />т.к. на нее ссылаются записи других таблиц.',
                                });
                            }), () => {
                            }),
                            disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                        },

                        // обновление таблицы
                        refresh: {
                            show: () => true,
                            click: $scope.refresh,
                            disabled: () => false,
                        },
                    },
                }
                ;

                // получение данных
                refresh();

                // region Function

                /**
                 * Получение всех записей
                 * @returns {*}
                 */
                function getItems() {
                    return $scope.items;
                }

                /**
                 * Выбран ли элемент!
                 * @param item проверяемый элемент
                 * @returns bool
                 */
                function isSelect(item) {
                    return equals(getSelected(), item);
                }

                /**
                 * Выбрать элемент
                 * @param item выбираемый элемент
                 */
                function select(item) {
                    if (!$scope.isSelect(item)) {
                        $scope.selectedItem = angular.copy(item);
                    } else {
                        $scope.selectedItem = angular.copy({});
                    }
                }

                /**
                 * Двойное нажатие на запись в таблице
                 * @param item данные записи
                 */
                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table':
                            $scope.toolbox.buttons.edit.click(item);
                            break;
                        case 'select':
                            $scope.ok(item);
                            break;
                    }
                }

                /**
                 * Получение фильтров
                 * @returns {Array}
                 */
                function getFilters() {
                    let filters = [];
                    if (Array.isArray($scope.filters)) {
                        filters = filters.concat($scope.filters);
                    }
                    return filters;
                }

                /**
                 * Получение поиска
                 * @returns {Array}
                 */
                function getSearchs() {
                    let searchs = [];
                    if ($scope.isSearch) {
                        if ($scope.searching.filter != null && !($scope.searching.filter.length < 1)) {
                            searchs.push('\'municipality.name\':\'' + $scope.searching.filter + '\'',
                                '\'regNum\':\'' + $scope.searching.filter + '\'');
                        }
                    }
                    return searchs;
                }

                /**
                 * Выбрана ли запись
                 * @returns {boolean}
                 */
                function isSelected() {
                    return $scope.selectedItem != null && !angular.equals($scope.selectedItem, {});
                }

                /**
                 * Проверка элементов на равенство
                 * @param i1
                 * @param i2
                 * @returns {*}
                 */
                function equals(i1, i2) {
                    if (i1 == i2) return true;
                    if (i1 != null && i2 != null) return angular.equals(i1.id, i2.id);
                    return false;
                }

                /**
                 * Получить выбранный элемент
                 * @returns {{}|*}
                 */
                function getSelected() {
                    return $scope.selectedItem;
                }

                /**
                 * Обновить данные таблицы
                 */
                function refresh() {
                    $scope.loading = true;
                    LandRestService.get({
                        filters: getFilters(),
                        searchs: getSearchs(),
                        sorts: [],
                        page: $scope.pagination.page,
                        size: $scope.pagination.size,
                    }, function(data) {
                        $scope.items = data._embedded;
                        if (isSelected()) {
                            if ($scope.items.every((i) => !equals(i, getSelected()))) {
                                $scope.selectedItem = {};
                            } else {
                                $scope.selectedItem = angular.copy($scope.items.find((i) => equals(i, getSelected())));
                            }
                        }
                        if ($scope.pagination.isPaging) {
                            $scope.pagination.totalPages = data.page.totalPages;
                            $scope.pagination.totalItems = data.page.totalElements;
                        }

                        $scope.loading = false;
                    });
                }

                // endregion

                // region Watchers

                $scope.$watch('filters', function() {
                    $scope.refresh();
                });

                // endregion
            }],
    };
}
